import { success } from "toastr";
import {
  FETCH_TASK,
  FETCH_TASK_SUCCESS,
  FETCH_TASK_FAILURE,
  FETCH_PROJECT_MODULE,
  FETCH_PROJECT_MODULE_SUCCESS,
  FETCH_PROJECT_MODULE_FAILURE,  
  FETCH_PROJECT_MODULE_CLEAR,
  SAVE_TASK,
  SAVE_TASK_SUCCESS,
  SAVE_TASK_FAILURE,
  CHANGE_TASK_STATUS,
  CHANGE_TASK_STATUS_SUCCESS,
  CHANGE_TASK_STATUS_FAILURE,
  GENERATE_TASK_ID,
  GENERATE_TASK_ID_SUCCESS,
  GENERATE_TASK_ID_FAILURE,
} from "./actionTypes";

const initialState = {
  task: [],
  projectModule:'',
  taskId: '',
  loading: false,
  error: null,
  success:false
};

const timesheetSetupTaskReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_TASK:
      return { ...state, loading: true };
    case FETCH_TASK_SUCCESS:
      return { ...state, loading: false, task: action.payload.data};
    case FETCH_TASK_FAILURE:
      return { ...state, loading: false, error: action.payload };    
    case FETCH_PROJECT_MODULE:
      return { ...state, loading: true, success: false };
    case FETCH_PROJECT_MODULE_SUCCESS:       
       return {
        ...state,
        loading: false,
        success: false,
        projectModule: {
          module: (action.payload?.data?.time_module ?? {}).map(module => ({
            value: module.module_id,
            label: module.module
          })),
          assignto: (action.payload?.data?.time_assignto ?? {}).map(emp => ({
            value: emp.emp_id,
            label: emp.emp_name
          })),
          tasktype: (action.payload?.data?.time_tasktype ?? {}).map(type => ({
            value: type.tasktype_id,
            label: type.task_type
          })),
          tasknature: (action.payload?.data?.time_tasknature ?? {}).map(nature => ({
            value: nature.task_nature_id,
            label: nature.task_nature
          })),
        },
      };
    case FETCH_PROJECT_MODULE_CLEAR:
      return { ...state, loading: false, success: false, projectModule: '' };     
    case FETCH_PROJECT_MODULE_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };
    case CHANGE_TASK_STATUS:
      return { ...state, loading: true, error: null, success: false };
    case CHANGE_TASK_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };
    case CHANGE_TASK_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    case SAVE_TASK:
      return { ...state, loading: true, success:false, error: null };    
    case SAVE_TASK_SUCCESS:
      return { ...state, loading: false, success:true, error: null };
    case SAVE_TASK_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };
    case GENERATE_TASK_ID:
      return { ...state, loading: true };
    case GENERATE_TASK_ID_SUCCESS:
      return { ...state, loading: false, taskId: action.payload };
    case GENERATE_TASK_ID_FAILURE:
      return { ...state, loading: false, error: action.payload };           
    default:
      return state;
  }
};

export default timesheetSetupTaskReducer;
